<h2 mat-dialog-title>Switch to {{ data.nextType }}?</h2>
<mat-dialog-content>
	<p>Serial <strong>{{ data.serialNo }}</strong>. {{ data.currentText }}</p>
	<p>
		The machine applies this the next time it is online, then reports back.
		Its registration record keeps its canister type.
	</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onCancel()">Cancel</button>
	<button mat-raised-button color="primary" type="button" (click)="onConfirm()">Switch to {{ data.nextType }}</button>
</mat-dialog-actions>
